import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import tokens from "../_tokens"
import ClipboardCopy from "./clipboard-copy"
import LiveCode from "./live-code"
import Highlight, { defaultProps } from "prism-react-renderer"
import githubTheme from "prism-react-renderer/themes/github"

const ClipboardCopyStyled = styled(ClipboardCopy)`
  position: absolute;
  top: 0;
  right: 0;
  padding: 0.5em 1em;
  margin: 0.5em;
`

const StyledCodeContainer = styled.pre`
  margin-top: 0;
  margin-bottom: ${1.5 * tokens.size.base}px;
  padding: ${1.5 * tokens.size.base}px;
  border: solid 1px ${tokens.color.bgLight};
  border-radius: 6px;
  overflow: auto;
`

function Code({ className, children, live, noinline, nocode }) {
  const language = className ? className.replace(/language-/, "") : ""
  const code = children.trim()

  if (live) {
    return (
      <LiveCode
        code={code}
        language={language}
        noinline={noinline}
        nocode={nocode}
      />
    )
  }

  const styleTokens = tokens //avoid naming conflict in StyledCodeContainer
  return (
    <div style={{ position: "relative" }}>
      <ClipboardCopyStyled value={code} />
      <Highlight
        {...defaultProps}
        code={code}
        language={language}
        theme={githubTheme}
      >
        {({ className, style, tokens, getLineProps, getTokenProps }) => (
          <StyledCodeContainer className={className} style={{ ...style }}>
            {tokens.map((line, i) => (
              <div key={i} {...getLineProps({ line, key: i })}>
                {line.map((token, key) => (
                  <span
                    key={key}
                    style={{
                      fontFamily: styleTokens.font.mono,
                      fontSize: styleTokens.fontSize.text.s,
                    }}
                    {...getTokenProps({ token, key })}
                  />
                ))}
              </div>
            ))}
          </StyledCodeContainer>
        )}
      </Highlight>
    </div>
  )
}

Code.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  live: PropTypes.bool,
  nocode: PropTypes.bool,
  noinline: PropTypes.bool,
}

export default Code
